/**
 * RP72 (MOA-A10, D20) — Glossaire du client : le registre public de
 * docs/REVUE-PRODUIT-2026-09/09-VOCABULAIRE.md.
 *
 * Chaque entrée donne le mot que le client lira (écran, compte rendu, documents),
 * le mot du métier qu'il peut croiser dans un document (`aussi`), et une explication
 * en français courant.
 */
export const GLOSSAIRE_PUBLIC = [
  {
    terme: 'Mon chantier',
    aussi: 'Chantier, opération',
    definition: "Votre projet de travaux, de la conception jusqu'à la fin de la garantie.",
  },
  {
    terme: 'Rendez-vous de chantier',
    aussi: 'Réunion de chantier',
    definition: "Réunion régulière sur place entre l'architecte et les entreprises. Vous pouvez y assister.",
  },
  {
    terme: 'Compte rendu de chantier',
    aussi: 'CR',
    definition: "Résumé écrit par l'architecte après chaque rendez-vous : ce qui a été fait, décidé, et ce qui reste à faire.",
  },
  {
    terme: 'Accord tacite',
    aussi: 'Validation tacite',
    definition: "Si vous ne signalez rien avant la date indiquée, le compte rendu est considéré comme accepté.",
  },
  {
    terme: 'Planning prévu',
    aussi: 'Planning de référence',
    definition: "Le calendrier des travaux tel qu'il a été fixé au départ. On le compare au planning actuel pour mesurer un retard.",
  },
  {
    terme: 'Choix des entreprises',
    aussi: 'Consultation, DCE, appel d\'offres',
    definition: "Étape où l'architecte demande des prix à plusieurs entreprises, puis vous aide à choisir.",
  },
  {
    terme: 'Détail du prix par poste',
    aussi: 'DPGF',
    definition: "Tableau qui détaille le prix de chaque ouvrage (quantité × prix unitaire) pour un lot de travaux.",
  },
  {
    terme: 'Description des travaux',
    aussi: 'CCTP',
    definition: "Document qui décrit précisément les travaux à réaliser et les matériaux à utiliser.",
  },
  {
    terme: "Contrat de l'entreprise",
    aussi: 'Marché, lot',
    definition: "Le contrat que vous signez avec chaque entreprise, pour un ensemble de travaux (un lot : maçonnerie, charpente…).",
  },
  {
    terme: 'Modification du marché (travaux en plus ou en moins)',
    aussi: 'Avenant',
    definition: "Changement du contrat d'une entreprise en cours de chantier : travaux ajoutés ou retirés, avec leur prix et leur effet sur le délai. Il demande votre accord.",
  },
  {
    terme: 'Ordre de démarrage ou instruction officielle',
    aussi: 'Ordre de service, OS',
    definition: "Document écrit qui donne une consigne officielle à une entreprise, par exemple la date de début des travaux.",
  },
  {
    terme: 'Plan vérifié',
    aussi: 'Visa, VSO, VAO',
    definition: "Plan d'exécution d'une entreprise contrôlé par l'architecte ou le bureau d'études avant les travaux.",
  },
  {
    terme: "Demande de paiement de l'entreprise, vérifiée par l'architecte",
    aussi: 'Situation de travaux',
    definition: "Chaque mois, l'entreprise demande à être payée pour les travaux réalisés. L'architecte vérifie et certifie le montant : c'est ce montant que vous payez.",
  },
  {
    terme: "Garantie de 5 % conservée jusqu'à la levée des réserves (1 an max.)",
    aussi: 'Retenue de garantie, RG',
    definition: "À chaque paiement, 5 % du montant des travaux est conservé. Cette somme est rendue à l'entreprise une fois les défauts corrigés, et au plus tard un an après la réception.",
  },
  {
    terme: 'Réception des travaux',
    aussi: 'Réception, OPR, AOR',
    definition: "Visite de fin de chantier où vous acceptez les travaux, avec ou sans défauts à corriger. Elle se conclut par la signature du PV de réception.",
  },
  {
    terme: 'PV de réception',
    aussi: 'Procès-verbal de réception',
    definition: "Document que vous signez à la réception des travaux. Il fait démarrer les garanties.",
  },
  {
    terme: 'Défaut à corriger',
    aussi: 'Réserve',
    definition: "Défaut relevé à la réception, que l'entreprise doit corriger. L'architecte vérifie ensuite la correction.",
  },
  {
    terme: 'Garantie de parfait achèvement (1 an)',
    aussi: 'GPA',
    definition: "Pendant un an après la réception, l'entreprise doit réparer les défauts signalés.",
  },
  {
    terme: 'Signature électronique par code SMS',
    aussi: 'Signature électronique',
    definition: "Vous signez un document en ligne en saisissant le code reçu par SMS sur votre téléphone.",
  },
];

export default GLOSSAIRE_PUBLIC;
